import React, { Suspense } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import Layout from "./components/layout";
import { useAuthState } from './context';
import TimesheetsIndex from "./pages/timesheets";
import ManageTimesheets from "./pages/timesheets/ManageTimesheets";


const LoginPage = React.lazy(() => import("./pages/login"));
const HomePage = React.lazy(() => import("./pages/home"));
const AdminWrapper = React.lazy(() => import("./pages/admin"));
const ServicesPage = React.lazy(() => import("./pages/services"));
const TechnologiesPage = React.lazy(() => import("./pages/technologies"));
const JobAspirantsPage = React.lazy(() => import("./pages/job-aspirants"));
const GeographiesPage = React.lazy(() => import("./pages/geographies"));
const InfoPage = React.lazy(() => import("./pages/info"));
const CareersJobsPage = React.lazy(() => import("./pages/careers/jobs"));
const CareersPage = React.lazy(() => import("./pages/careers"));

const AllRoutes = [
     {
          path: "/careers/jobs",
          component: CareersJobsPage,
          isPrivate: false
     },
     {
          path: "/careers",
          component: CareersPage,
          isPrivate: false
     },

     {
          path: "/admin",
          component: AdminWrapper,
          isPrivate: true
     },
     {
          path: "/home",
          component: HomePage,
          isPrivate: false
     },
     {
          path: "/services",
          component: ServicesPage,
          isPrivate: false
     },
     {
          path: "/technologies",
          component: TechnologiesPage,
          isPrivate: false
     },
     {
          path: "/job-aspirants",
          component: JobAspirantsPage,
          isPrivate: false
     },
     {
          path: "/geographies", // also fixed typo here
          component: GeographiesPage,
          isPrivate: false
     },
     {
          path: "/info",
          component: InfoPage,
          isPrivate: false
     },
     {
          path: "/timesheets",
          component: TimesheetsIndex,
          isPrivate: true,
     },
     {
          path: "/timesheets/manage",
          component: ManageTimesheets,
          isPrivate: true,
     },
     {
          path: "/login",
          component: LoginPage,
          isPrivate: false
     }
];

const AppRoutes = ({ component: Component, path, isPrivate, ...rest }: any) => {
     const userDetails = useAuthState();

     return (
         <Route
             {...rest}
             exact
             path={path}
             render={(routeProps) =>
                 isPrivate && !Boolean(userDetails.token) ? (
                     <Redirect to="/login" />
                 ) : (
                     <Component {...routeProps} />
                 )
             }
         />
     );
};

export default function Routes() {
     // const [token, setToken] = useState('');      //useState(auth.details?.token);
     const auth = useAuthState();
     // function NoMatch() {
     //      const location = useLocation();

     //      return (
     //           <div>
     //                <h3>Error 404</h3>
     //                <p>
     //                     No match for <code>{location.pathname}</code>
     //                </p>
     //           </div>
     //      );
     // }

     // function LogOut() {
     //      // auth.logout();
     //      // setToken(null);
     //      return (
     //           <Redirect to="/home" push />
     //      )
     // }

     return (
          <>
               <Router>
                    <Layout token={auth.token}>
                         <Suspense fallback={<code>Loading...</code>}>
                              <Switch>
                                   {AllRoutes.map((route) => (
                                        <AppRoutes
                                             key={route.path}
                                             path={route.path}
                                             component={route.component}
                                             isPrivate={route.isPrivate}
                                        />
                                   ))}
                                   <Redirect exact from="/" to="/home" />
                              </Switch>
                              {/* {token ? (
                                   <Switch>
                                        <Redirect exact from="/" to="/admin" />
                                        <Redirect exact from="/login" to="/admin" />
                                        <Route path="/admin" component={AdminWrapper} />
                                        <Route path="/logout" component={LogOut} />
                                   </Switch>
                              ) : (
                                   <Switch>
                                        <Redirect exact from="/" to="/home" />
                                        <Route path="/home" component={HomePage} />
                                        <Route path="/services" component={ServicesPage} />
                                        <Route path="/technologies" component={TechnologiesPage} />
                                        <Route path="/job-aspirants" component={JobAspirantsPage} />
                                        <Route path="/georgaphies" component={GeographiesPage} />
                                        <Route path="/info" component={InfoPage} />

                                        <Route path="/login" component={LoginPage} />

                                        <Route path="*" component={NoMatch} />
                                   </Switch>
                              )} */}
                         </Suspense>
                    </Layout>
               </Router>
          </>
     );
}
